module.exports = __webpack_public_path__ + "media/images/background_approach_white-be85c93fee56bce72400ab8635cbb24c.png";